export const organizationEntitlementsQuery = /* GraphQL */ `
  query OrganizationEntitlements {
    organizationEntitlements {
      state
      reason
      access
      organizationID
      licenseOrganizationID
      inherited
      subscriptionID
      subscriptionStatus
      graceEndsAt
      callerSeatAccess {
        state
        reason
        graceStartedAt
        graceEndsAt
      }
      quotas {
        quotaType
        limit
        used
        remaining
        enforcementLimit
        temporaryUsed
        required
        shortfall
      }
    }
  }
`
